const ctx = require.context('./uoa_images', false, /\.jpe?g$/i)

function basename(key) {
	return key.replace(/^\.\//, '')
}

function sortKeys(keys) {
	return [...keys].sort((a, b) => {
		const na = parseInt(String(a.match(/uoa-(\d+)/i)?.[1] ?? '0'), 10)
		const nb = parseInt(String(b.match(/uoa-(\d+)/i)?.[1] ?? '0'), 10)
		if (na !== nb) return na - nb
		return a.localeCompare(b)
	})
}

/** @typedef {{ id: string, src: string, label: string }} UoaGalleryItem */

/** @type {UoaGalleryItem[]} */
export const UOA_GALLERY_ITEMS = sortKeys(ctx.keys()).map((key) => {
	const file = basename(key)
	const id = file.replace(/\.jpe?g$/i, '')
	return {
		id,
		src: ctx(key),
		label: file,
	}
})

/**
 * Shape compatible with PickerDrawFlip / getBggGameCoverUrl / gameTitle().
 * @param {UoaGalleryItem} item
 */
export function uoaItemToRollShim(item) {
	return {
		'@_objectid': item.id,
		image: item.src,
		thumbnail: item.src,
		name: { '#text': item.label },
	}
}
